import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { GET_ALL_DRAFTS_META_DATA } from 'graphql/queries/job'
import _map from 'lodash-es/map'
import { useAuth } from 'contexts/AuthContext'

export const useDraftedJobIds = ({ skip = true }) => {
  const { isLoggedIn } = useAuth()
  const [draftedJobIdsCache, setDraftedJobIdsCache] = useState<string[]>([])
  const { data } = useQuery(GET_ALL_DRAFTS_META_DATA, {
    fetchPolicy: 'cache-and-network',
    skip: skip || !isLoggedIn,
  })

  const addDraftedJobIdToCache = (jobRefClean: string) => {
    if (draftedJobIdsCache.includes(jobRefClean)) return
    setDraftedJobIdsCache((vals) => [...vals, jobRefClean])
  }

  const removeDraftFromCache = (jobRefClean: string) => {
    setDraftedJobIdsCache((vals) => vals.filter((jrf) => jrf !== jobRefClean))
  }

  useEffect(() => {
    if (!data) return
    const fetchedDraftApplicationsList =
      data?.currentUserData?.[0]?.draftApplications
    setDraftedJobIdsCache(
      _map(fetchedDraftApplicationsList, 'jobReferenceClean')
    )
  }, [data])

  return {
    draftedJobIdsCache,
    removeDraftFromCache,
    addDraftedJobIdToCache,
  }
}
